/**
 * WizCalendar 日历
 * @author jzhu
 * @date 2020-06-02
 */

import React from 'react'
import { component_tool } from '@/tool'
const { WizComponent, WizCard, WizRow, WizCol, WizForm } = component_tool
import { Badge } from 'antd'

import WizCalendar from './wizCalendar'

export default class WizCalendarDemo extends WizComponent {

    _renderDateCell = (info) => {
        let { date } = info
        if (date.day === 10) {
            let listData = [
                { type: 'warning', content: 'This is warning event.' },
                { type: 'success', content: 'This is very long usual event.' },
                { type: 'error', content: 'This is error event 1.' },
                { type: 'error', content: 'This is error event 2.' },
                { type: 'error', content: 'This is error event 3.' },
                { type: 'error', content: 'This is error event 4.' }
            ]
            let result = listData.map(item => (
                <li key={item.content} style={{ width: 300 }} >
                    <Badge status={item.type} text={item.content} />
                </li>
            ))
            return <ul>{result}</ul>
        }
    }

    _onDate = (date) => {
        console.log('date ---> ', date)
    }

    render() {
        let calendarProps = {
            renderDateCell: this._renderDateCell,
            // weekTitle: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
            // tooltipProps: { visible: false },
            // disabled: WizCalendar.DISABLED_WEEKEND,
            // showDays: WizCalendar.SHOW_SAME,
            // onDate: this._onDate
        }
        return (
            <>
                <WizCard title='日历'>
                    <WizCalendar {...calendarProps} />
                </WizCard>
            </>
        )
    }
    
}